import Notify from "devextreme/ui/notify";
import { toastDefaultConfig } from "./index";
export const NOTIFY_MESSAGE_TYPE = {
  INFO: "info",
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",
};
interface IMdaeNotifyConfig {
  message: string;
  messageType: string;
}
const mdaeNotify = (config: IMdaeNotifyConfig) => {
  Notify(
    { ...toastDefaultConfig, message: config.message },
    config.messageType,
    toastDefaultConfig.displayTime
  );
};

export default mdaeNotify;
